import React, { useEffect, useState } from 'react'
import { getStorage, ref, uploadBytes } from "firebase/storage";
import { getFirestore, query, onSnapshot, collection, orderBy } from "firebase/firestore";
import { initializeApp } from "firebase/app";
import * as XLSX from "xlsx";
import Title from '../../components/Title/Title';
import logo from '../../assets/logosnowcamp.png'
import Button from '../../components/Button/Button';
import { Navigate } from 'react-router-dom';
import { FaHome } from "react-icons/fa";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import moment from 'moment';
import 'moment/locale/it';

const firebaseConfig = {
    apiKey: "AIzaSyC1BE8O5HQJ6VQcHU-29djLySMJvIC8OCQ",
    authDomain: "bookingsnowcamp.firebaseapp.com",
    databaseURL: "https://bookingsnowcamp-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "bookingsnowcamp",
    storageBucket: "bookingsnowcamp.appspot.com",
    messagingSenderId: "394603355230",
    appId: "1:394603355230:web:b5e36ae8485e76d8e168cf",
    measurementId: "G-YC4N5NZH76"
};

firebase.initializeApp(firebaseConfig)
const db = firebase.firestore();

const app = initializeApp(firebaseConfig);
// const db = getFirestore(app);
const guestsRef = db.collection("guests");
const q = query(collection(db, "guests"));
const storage = getStorage(app);
const storageRef = ref(storage, 'RegistrazioniSnowCamp.xlsx');

const Done = () => {
    const [home, setHome] = useState(false);
    const [file, setFile] = useState();
    const [profiles, setProfiles] = useState();
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let unsubscribe = () => { };

    const exportToCSV = (apiData, fileName) => {
        const ws = XLSX.utils.json_to_sheet(apiData);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        setFile(data);
    };


    const uploadFile = () => {
        uploadBytes(storageRef, file, { contentType: fileType }).then((snapshot) => {
            console.log('Uploaded a blob or file!');
        });
    }

    async function getFirebaseData() {
        // unsubscribe = onSnapshot(q, (snapshot) => {
        //     let data = []
        //     snapshot.forEach((doc) => {
        //         if (doc.exists()) {
        //             data.push({
        //                 "Nome": doc.data().name,
        //                 "Cognome": doc.data().surname,
        //                 "Email": doc.data().email,
        //                 "Cellulare": doc.data().phone,
        //                 "Indirizzo": doc.data().address,
        //                 "Intolleranze": doc.data().allergy,
        //                 "Data di nascita": doc.data().birth,
        //                 "Luogo di nascita": doc.data().birthCity,
        //                 "Sesso": doc.data().sex,
        //                 "Preferenza Stanza": doc.data().room,
        //                 "Data": doc.data().date
        //             })
        //         }
        //     })
        //     setProfiles(data)
        // })
        let data = []
        guestsRef.orderBy('date', 'desc')
            .get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    data.push({
                        "Nome": doc.data().name,
                        "Cognome": doc.data().surname,
                        "Email": doc.data().email,
                        "Cellulare": doc.data().phone,
                        "Indirizzo": doc.data().address,
                        "Intolleranze": doc.data().allergy,
                        "Data di nascita": doc.data().birth,
                        "Luogo di nascita": doc.data().birthCity,
                        "Sesso": doc.data().sex,
                        "Preferenza Stanza": doc.data().room,
                        "Data": moment(doc.data().date).format("DD/MM/YYYY HH:mm:ss")
                    })
                });
                setProfiles(data)
            })
            .catch(error => {
                console.error("Error getting documents: ", error);
            });
    }

    useEffect(() => {
        getFirebaseData();
        return unsubscribe
    }, []);

    useEffect(() => {
        if (profiles) {
            unsubscribe();
            exportToCSV(profiles, "Registrazioni");
        }
    }, [profiles])

    useEffect(() => {
        if (file) {
            uploadFile();
        }
    }, [file])

    return (
        <div className='container'>
            {home && <Navigate to="/" />}
            {/* <img src={logo} alt="" /> */}
            <Title>
                registrazione effettuata con sucesso!
            </Title>
            <label className='subtitle'>A breve riceverai una mail di conferma della tua registrazione.</label>
            <Button onClick={() => { setHome(true) }}><FaHome /></Button>
        </div>
    )
}

export default Done